import { render, staticRenderFns } from "./MomSubapp.vue?vue&type=template&id=d52d53a4&scoped=true"
import script from "./MomSubapp.vue?vue&type=script&lang=js"
export * from "./MomSubapp.vue?vue&type=script&lang=js"
import style0 from "./MomSubapp.vue?vue&type=style&index=0&id=d52d53a4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d52d53a4",
  null
  
)

export default component.exports